// extracted by mini-css-extract-plugin
export var cardSelected = "_g4-2";
export var image = "_g4-1";
export var table = "_g4-0";